'use strict';
import request from '@/utils/request';
class AdditionalsService{
    static list(query){
        return request({
            url:'/user/help',
            method:'get',
            timeout:60000,
            params:query
        })
    }
    static apply(query){
        return request({
            url:'/user/help-apply',
            method:'get',
            timeout:60000,
            params:query
        })
    }
    static findSymptomps(query){
        return request({
            url:'/user/symptomps-checked',
            method:'get',
            timeout:60000,
            params:query
        })
    }
    static createTest(data){
        return request({
            url:'/user/create-test-covid-19',
            method:'post',
            data
        });
    }
    static updateTest(data){
        return request({
            url:'/user/update-test-covid-19',
            method:'put',
            data
        });
    }
    static finishSymptoms(data){
        return request({
            url:'/user/finish-test-covid-19',
            method:'put',
            data
        });
    }
    static uploadHelp(data){
        return request({
            url:'/user/photo-help',
            method:'post',
            data
        });
    }
    static create(data){
        return request({
            url:'/user/help',
            method:'post',
            data
        });
    }
    static update(data){
        return request({
            url:'/user/help',
            method:'put',
            data
        });
    }
    static remove(data){
        return request({
            url:'/user/help',
            method:'delete',
            data
        });
    }
    static search(query){
        return request({
            url:'/company/additional-service/search',
            method:'get',
            params:query
        })
    }
}

export default AdditionalsService;
